import React from "react";
import "../css/footer.css";

const whatsappUrl = "https://wa.me/51995513505";

const WhatsAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="currentColor"
    viewBox="-1 -1 18 18"
    aria-hidden="true"
  >
    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .07 3.556.068 7.922c-.002 1.407.367 2.78 1.067 3.99L0 16l4.184-1.096a7.933 7.933 0 0 0 3.808.97h.003c4.365 0 7.922-3.556 7.924-7.922a7.874 7.874 0 0 0-2.318-5.626zM7.995 14.53a6.57 6.57 0 0 1-3.35-.916l-.24-.144-2.484.651.663-2.423-.156-.248a6.54 6.54 0 0 1-1.002-3.49c.002-3.842 3.13-6.97 6.976-6.97a6.93 6.93 0 0 1 4.932 2.044 6.93 6.93 0 0 1 2.039 4.935c-.002 3.84-3.13 6.97-6.978 6.97z" />
    <path d="M11.746 9.852c-.209-.104-1.234-.609-1.425-.678-.191-.07-.33-.104-.468.104-.139.209-.538.678-.66.817-.122.139-.243.156-.452.052-.208-.104-.88-.325-1.676-1.036-.62-.553-1.04-1.235-1.162-1.443-.122-.209-.013-.321.092-.425.094-.094.209-.244.313-.365.104-.122.139-.209.209-.348.07-.139.035-.261-.017-.365-.052-.104-.469-1.13-.643-1.547-.17-.407-.343-.352-.469-.358l-.4-.007c-.14 0-.365.052-.556.261-.191.209-.73.713-.73 1.738s.747 2.017.851 2.156c.104.139 1.47 2.244 3.562 3.145.497.214.885.342 1.188.438.499.159.953.136 1.312.082.4-.06 1.234-.505 1.408-.991.174-.487.174-.904.122-.991-.052-.087-.191-.139-.4-.244z" />
  </svg>
);

const Footer = ({ showMore = true }) => (
  <>
    {showMore && (
      <section className="footer-more" aria-labelledby="footer-more-title">
        <h2 id="footer-more-title">Saiba Mais</h2>
        <a
          className="footer-contact-button"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Fale Conosco
        </a>
      </section>
    )}

    <footer className="site-footer" id="contato">
      <div className="footer-main">
        <section
          className="footer-column"
          aria-labelledby="footer-contact-title"
        >
          <h3 id="footer-contact-title">Contato</h3>
          <address>
            <p>Av. Presidente Vargas, 1698, Sala 101</p>
            <a href="tel:+5551995513505">(51) 99551-3505</a>
            <a href="tel:+5551981889980">(51) 98188-9980</a>
            <a href="mailto:dalmo@dalmosouza.com.br">dalmo@dalmosouza.com.br</a>
          </address>
        </section>

        <nav className="footer-column" aria-labelledby="footer-links-title">
          <h3 id="footer-links-title">Links</h3>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
            WhatsApp
          </a>
          <a href="#contato">Contate-nos</a>
        </nav>
      </div>

      <div className="footer-legal">
        <p>
          Copyright © {new Date().getFullYear()}. Todos os direitos reservados —
          Imobiliária Dalmo Souza Ltda
        </p>
        <p>
          Desenvolvido por <strong>Gestor Imobiliário 360</strong>
        </p>
      </div>
    </footer>

    <a
      className="whatsapp-float"
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <WhatsAppIcon />
    </a>
  </>
);

export default Footer;
